import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8h4","key":"svg-0"}],["path",{"d":"M5 8v8","key":"svg-1"}],["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8","key":"svg-2"}],["path",{"d":"M14 16l-3 -4","key":"svg-3"}],["path",{"d":"M17 16v-6a2 2 0 1 1 4 0v6","key":"svg-4"}],["path",{"d":"M17 13h4","key":"svg-5"}]]

const IconHttpTrace = createReactComponent('outline', 'http-trace', 'HttpTrace', __iconNode);

export default IconHttpTrace;